import { AdrTabTemplate } from "@/pages/TriagePage/components/templates/AdrTabTemplate"
import { ContainThreatStep } from "./ContainThreatStep"
import { KaiStep } from "./KaiStep"
import { RemediateHardenStep } from "./RemediateHardenStep"

import type { Props } from "./NextStepsTabAdr.types"

export const NextStepsTabAdr = (props: Props) => {
  return (
    <AdrTabTemplate>
      <ContainThreatStep {...props} />
      <RemediateHardenStep {...props} />
      <KaiStep />
    </AdrTabTemplate>
  )
}
